import EstadisticasApiService from './EstadisticasApiService';
import LogsProcessor from '../utils/LogsProcessor';
import MetricasCalculadora from '../utils/MetricasCalculadora';

/**
 * Servicio principal para obtener estadísticas de órdenes
 */
class EstadisticasOrdenService {
  constructor() {
    // No necesitamos instanciar servicios ya que usamos métodos estáticos
  }

  /**
   * Obtiene las estadísticas completas de una orden
   * @param {string} ordenId - ID de la orden
   * @returns {Promise<Object>} Objeto con procesos y resumen
   */
  async obtenerEstadisticasOrden(ordenId) {
    try {
      
      // Obtener datos de la API usando el método estático
      const datos = await EstadisticasApiService.getEstadisticasOrden(ordenId);
      
      if (!datos || !datos.procesos || datos.procesos.length === 0) {
        return {
          procesos: [],
          resumen: null,
          error: 'No se encontraron datos de procesos para esta orden'
        };
      }

      
      return {
        procesos: datos.procesos,
        resumen: datos.resumen,
        error: null
      };
    } catch (error) {
      console.error('Error obteniendo estadísticas:', error);
      return {
        procesos: [],
        resumen: null,
        error: `Error al obtener estadísticas: ${error.message}`
      };
    }
  }

  /**
   * Obtiene solo los procesos de una orden
   * @param {string} ordenId - ID de la orden
   * @returns {Promise<Array>} Array de procesos
   */
  async obtenerProcesosOrden(ordenId) {
    try {
      const datos = await EstadisticasApiService.getProcesosEstadisticas(ordenId);
      return datos;
    } catch (error) {
      console.error('Error obteniendo procesos:', error);
      return [];
    }
  }

  /**
   * Obtiene solo el resumen de una orden
   * @param {string} ordenId - ID de la orden
   * @returns {Promise<Object>} Objeto resumen
   */
  async obtenerResumenOrden(ordenId) {
    try {
      const datos = await EstadisticasApiService.getResumenEstadisticas(ordenId);
      return datos;
    } catch (error) {
      console.error('Error obteniendo resumen:', error);
      return null;
    }
  }
}

export default EstadisticasOrdenService;